import React, { useState } from 'react';
import axios from 'axios';

const CouponInput = ({ onCouponApplied, onCouponRemoved, type = 'subject' }) => {
    const [couponCode, setCouponCode] = useState('');
    const [loading, setLoading] = useState(false);
    const [appliedCoupon, setAppliedCoupon] = useState(null);
    const [error, setError] = useState('');

    const applyCoupon = async () => {
        if (!couponCode.trim()) return;
        
        setLoading(true);
        setError('');
        
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/payment/validate-coupon`,
                { code: couponCode }
            );
            
            if (response.data.valid) {
                setAppliedCoupon(response.data.coupon);
                onCouponApplied(response.data.coupon);
                setError('');
            } else {
                setError(response.data.error || 'Invalid coupon code');
            }
        } catch (err) {
            setError(err.response?.data?.error || 'Error applying coupon');
        } finally {
            setLoading(false);
        }
    };

    const removeCoupon = () => {
        setAppliedCoupon(null);
        setCouponCode('');
        onCouponRemoved();
        setError('');
    };

    return (
        <div className="mb-4">
            {!appliedCoupon ? (
                <div className="flex flex-col sm:flex-row gap-2">
                    <input
                        type="text"
                        placeholder="Enter coupon code"
                        value={couponCode}
                        onChange={(e) => setCouponCode(e.target.value.toUpperCase())}
                        className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                    <button
                        onClick={applyCoupon}
                        disabled={loading || !couponCode.trim()}
                        className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {loading ? 'Applying...' : 'Apply'}
                    </button>
                </div>
            ) : (
                <div className="flex items-center justify-between p-3 bg-green-50 border border-green-200 rounded-md">
                    <div>
                        <span className="font-medium text-green-800">
                            Coupon applied: {appliedCoupon.name}
                        </span>
                        <span className="ml-2 text-green-600">
                            ({appliedCoupon.discount_type === 'percentage' ? 
                                `${appliedCoupon.discount_value}% off` : 
                                `$${appliedCoupon.discount_value} off`})
                        </span>
                    </div>
                    <button
                        onClick={removeCoupon}
                        className="text-red-600 hover:text-red-800"
                    >
                        Remove
                    </button>
                </div>
            )}
            {error && <p className="mt-1 text-red-600 text-sm">{error}</p>}
        </div>
    );
};

export default CouponInput;